//angular imports
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';

//local imports
import { DepartmentGroupModel } from '@app/catalog';
import { PresenterType } from '@app/shared';

@PresenterType({
  model: DepartmentGroupModel,
  key: 'tileTop'
})
@Component({
  selector: 'department-group-carousel-item',
  standalone: false,
  templateUrl: './department-group-carousel-item.component.html',
  styleUrl: './department-group-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepartmentGroupCarouselItemComponent {
  public data: WritableSignal<DepartmentGroupModel> = signal<DepartmentGroupModel>(undefined);
}
